import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "shadow-sm mt-2 position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "position-absolute top-0 start-0 translate-middle"
}
const _hoisted_3 = {
  key: 1,
  class: "position-absolute top-100 start-100 translate-middle"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-text mb-2" }
const _hoisted_8 = { class: "badge rounded-pill bg-success" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "badge rounded-pill bg-warning text-light" }
const _hoisted_11 = { class: "badge rounded-pill bg-info" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_14 = { class: "badge rounded-pill bg-primary text-light" }
const _hoisted_15 = { class: "badge rounded-pill bg-dark text-light" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Se sæt ")


import { Legosaet } from "@/types/legotyper";


export default /*#__PURE__*/_defineComponent({
  __name: 'LegoSetCard',
  props: {
    legosaet: null
  },
  emits: ["settema"],
  setup(__props: any, { emit }: { emit: ({
  (e: "settema", value: { hovedtema: string; undertema?: string }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  legosaet: Legosaet;
}





return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.legosaet.kildesHarSetConnection.edges.length > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'check-circle'] })
          ]))
        : _createCommentVNode("", true),
      (__props.legosaet.fotograferet)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'camera'] })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        class: "img-fluid",
        style: {"float":"left","width":"200px","height":"150px","object-fit":"contain"},
        src: __props.legosaet.url,
        alt: __props.legosaet.nummer
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h6", _hoisted_6, _toDisplayString(__props.legosaet.navn), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_font_awesome_icon, { icon: "hashtag" }),
          _createTextVNode(" " + _toDisplayString(__props.legosaet.nummer), 1)
        ]),
        (Number(__props.legosaet.version) > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, " v" + _toDisplayString(__props.legosaet.version), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_11, [
          (__props.legosaet.harTemaTemas[0]?.undertemaTilTemas?.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _createElementVNode("span", {
                  class: "fremhaev",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (
              _ctx.$emit('settema', {
                hovedtema: __props.legosaet.harTemaTemas[0].undertemaTilTemas[0].navn
              })
            ))
                }, _toDisplayString(__props.legosaet.harTemaTemas[0].undertemaTilTemas[0].navn), 1),
                _hoisted_13
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: "fremhaev",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.$emit('settema', {
              hovedtema:
                __props.legosaet.harTemaTemas[0].undertemaTilTemas.length > 0
                  ? __props.legosaet.harTemaTemas[0].undertemaTilTemas[0].navn
                  : __props.legosaet.harTemaTemas[0].navn,
              undertema:
                __props.legosaet.harTemaTemas[0].undertemaTilTemas.length > 0
                  ? __props.legosaet.harTemaTemas[0].navn
                  : undefined
            })
          ))
          }, _toDisplayString(__props.legosaet.harTemaTemas[0].navn), 1)
        ]),
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_font_awesome_icon, { icon: ['far', 'calendar'] }),
          _createTextVNode(" " + _toDisplayString(__props.legosaet.aarstal), 1)
        ]),
        _createElementVNode("span", _hoisted_15, _toDisplayString(__props.legosaet.antalKlodser), 1)
      ]),
      _createVNode(_component_router_link, {
        to: {
        name: 'set',
        params: { uuid: __props.legosaet.uuid, setnum: __props.legosaet.nummer }
      },
        class: "btn btn-outline-primary btn-sm"
      }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ], 64))
}
}

})